import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from '@/core/auth/AuthContext';
import { categoriesDetailService } from '../services/categoriesDetail.service';

export function useCategoriesDetail(id: string | null) {
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  const userId = profile?.id || '';
  const companyId = profile?.company_id || '';

  const categoryQuery = useQuery({
    queryKey: ['settings', 'categories', 'detail', id],
    queryFn: () => (id ? categoriesDetailService.getCategoryDetail(id) : null),
    enabled: !!id,
  });

  const subCategoriesQuery = useQuery({
    queryKey: ['settings', 'categories', 'sub', id],
    queryFn: () => (id ? categoriesDetailService.getSubCategories(id) : []),
    enabled: !!id,
  });

  const linkedServicesQuery = useQuery({
    queryKey: ['settings', 'categories', 'services', id],
    queryFn: () => (id ? categoriesDetailService.getLinkedServices(id) : []),
    enabled: !!id,
  });

  const statsQuery = useQuery({
    queryKey: ['settings', 'categories', 'stats', id],
    queryFn: () => (id ? categoriesDetailService.getCategoryStats(id) : []),
    enabled: !!id,
  });

  const deleteMutation = useMutation({
    mutationFn: async (catId: string) => {
        const { categoriesListService } = await import('../../list/services/categoriesList.service');
        return categoriesListService.deleteCategory(catId, userId, companyId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'categories'] });
      toast.success('Đã xóa danh mục thành công');
    },
    onError: (error: any) => toast.error(`Lỗi khi xóa: ${error.message}`),
  });

  return {
    category: categoryQuery.data || null,
    subCategories: subCategoriesQuery.data || [],
    linkedServices: linkedServicesQuery.data || [],
    stats: statsQuery.data || [],
    isLoading: categoryQuery.isLoading || subCategoriesQuery.isLoading || linkedServicesQuery.isLoading || statsQuery.isLoading,
    isDeleting: deleteMutation.isPending,
    deleteCategory: deleteMutation.mutate,
  };
}
